import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

export default class extends Controller {
  static values = { target: String, checkbox: String }

  toggle(event) {
    const show = event.target.checked
    $(`.${this.targetValue}`).collapse(show ? "show" : "hide")
    document.querySelectorAll(`.${this.checkboxValue}`).forEach((checkbox) => { checkbox.checked = show })
  }
}
